import * as z from 'zod'
import {SortSchema} from '@cypro/ui/schemas'
import {CatalogType} from '@cypro/engine/database/schema'
import {StockStatus} from '@cypro/engine/queries'
import {CONSUMABLES_CATEGORIES} from '@cypro/engine/database/schema'
import {StocksFiltersSchema} from '@/modules/stocks/schemas'

export const BatchFiltersSchema = StocksFiltersSchema.extend({
  types: z.array(z.union([CatalogType, z.literal('consumable')])).optional(),
  categories: z.array(z.union([z.uuid(), z.enum(CONSUMABLES_CATEGORIES)])).optional(),
  subcategories: z.array(z.uuid()).optional(),
  suppliers: z.array(z.uuid()).optional(),
  stockLocations: z.array(z.uuid()).optional(),
  status: z.array(StockStatus).optional(),
})

export const BatchFormSchema = z
  .object({
    id: z.uuid().optional(),
    barcode: z.string().optional(),
    lotNumber: z.string().min(1),
    productId: z.uuid().min(1),
    nationalId: z.string().optional(),
    supplierCompanyId: z.union([z.uuid(), z.literal('')]).optional(),
    expiryDate: z.array(z.any()).min(1),
    receivedQuantity: z.number().positive(),
    quantity: z.number().nonnegative(),
    stockLocationId: z.uuid().min(1),
    note: z.string().optional(),
  })
  .refine(data => data.quantity <= data.receivedQuantity, {
    params: {tKey: 'quantity_exceeded'},
    path: ['quantity'],
  })

export type BatchFormSchema = z.infer<typeof BatchFormSchema>

export const BatchesSearchSchema = z.object({
  filters: BatchFiltersSchema.optional(),
  sort: z.array(SortSchema).default([{id: 'createdAt', desc: true}]),
})

export const NewBatchSearchSchema = z.object({
  batchId: z.string().uuid().optional(),
})
